export default "__VITE_ASSET__C1Y0FtyK__"